import { TFunction, useTranslation } from 'next-i18next';
import { ReactElement } from 'react';

import { Typography } from '@/shared/components/atoms';
import Tabs from '@/shared/components/atoms/Tabs';

import ClockIcon from '~/images/shared/OtherClock.svg';
export const TAB_QUERY_INDICATOR = 'timelineType';

const getTimelineTabsList = (t: TFunction) => [
  {
    label: t('timeline-operations'),
    value: 'operations',
  },
  {
    label: t('the-alerts'),
    value: 'alerts',
  },
];
const TimelineHeader = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <div className='border-b-xs border-grey-200 border-opacity-5'>
      <div className='flex  flex-wrap items-center justify-between gap-8  p-16'>
        <span className='inline-flex items-center gap-8'>
          <ClockIcon className=' text-24' />
          <Typography weight='bold' variant='subtitle1' className='capitalize'>
            {t('timeline')}
          </Typography>
        </span>
        <Tabs
          getLabel={(item) => item?.label}
          getValue={(item) => item?.value}
          tabsList={getTimelineTabsList(t)}
          variant='connected'
          defaultValue='operations'
          tabQueryIndicator={TAB_QUERY_INDICATOR}
          linkClassName='px-12 py-3'
          activeClassName='!bg-blue-100 '
        />
      </div>
    </div>
  );
};
export { TimelineHeader };
